export default __webpack_public_path__ + "static/media/31.55aa9dbf.png";